module.exports = __webpack_public_path__ + "media/assets/ArrowLeft-8731465494d497a27d2c3080ac984e4b.svg";